module.exports = __webpack_public_path__ + "img/type_back.15a40db0.png";